import React, { useEffect, useState, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import CaseList from "../CaseList";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import { getCaseCategoryByCaseType } from "../../../../utils";
import { TableListLoader } from "../../../../components/Loader/TableListLoader";
import { FormLoader } from "../../../../components/Loader/FormLoader";
import {
  getPolicyDetailById,
  getPolicyListItems,
} from "../../../../redux/Case/policySlice";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import { Toaster } from "@fluentui/react-components";

interface PolicyDetailPageProps {
  tab?: string;
}

const PolicyDetailPage: React.FC<PolicyDetailPageProps> = ({ tab }) => {
  const { clientId, action, caseId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { showToast, toasterId } = useToastMessage();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const { activeItem, listItems, loading, activeItemloading } = useSelector(
    (state: RootState) => state.policies
  );

  const [caseType, setCaseType] = useState<string>("");

  useEffect(() => {
    if (location.state?.caseType) {
      setCaseType(location.state.caseType);
    }
  }, [location.state?.caseType]);
  useEffect(() => {
    if (action && action?.length > 5) {
      navigate(
        `/clients/${clientId}/policies/${action}/${tab || "policy"}/view`
      );
    }
    if (!action && caseId) {
      navigate(
        `/clients/${clientId}/policies/${caseId}/${tab || "policy"}/view`
      );
    }
  }, [action, caseId]);
  useEffect(() => {
    if (clientId) {
      dispatch(getPolicyListItems(clientId));
    }
  }, [clientId, dispatch]);

  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getPolicyDetailById({ id: caseId, customerId: clientId }));
    }
  }, [caseId, clientId, dispatch]);

  useEffect(() => {
    if (activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(activeItem.case_type));
    }
  }, [activeItem]);

  const hasListItems = useMemo(() => listItems.length > 0, [listItems]);

  return (
    <>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      {action && (
        <CaseNavList
          menuItem={undefined}
          section="policies"
          tab={tab}
          caseType={caseType}
          caseDetail={activeItem}
          mode={action || ""}
        />
      )}
      <div className="case_container_flex">
        {action &&
          (activeItemloading ? (
            <FormLoader />
          ) : (
            <CaseForm
              mode={action || ""}
              section="policies"
              caseType={caseType}
              caseDetail={activeItem}
              caseItemList={listItems}
              tab={tab}
              notify={showToast}
              currentRecord={currentRecord}
              setCurrentRecord={setCurrentRecord}
            />
          ))}
        <div>
          {loading ? (
            <TableListLoader rows={8} columns={6} />
          ) : (
            hasListItems &&
            listItems.length > 0 && (
              <CaseList
                module="policies"
                data={listItems}
                activeItem={activeItem}
                section="policies"
                tab={tab}
                currentRecord={currentRecord}
                setCurrentRecord={setCurrentRecord}
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default PolicyDetailPage;
